import React from 'react';
import {
  Mail, Smartphone, CreditCard, Laptop, Phone, Car, Wallet, Shirt, Contact, Code, Package,
} from 'lucide-react';

/**
 * Iconos de recurso: `incorp_recursos.icono` (kebab-case) → componente lucide. Fallback: Package.
 *
 * Estaba en WizardAlta.jsx y lo necesita también el panel de detalle (Fase 10), así que sale a
 * módulo compartido del propio módulo —junto a `fecha.js` y `paletaAreas.js`—, en vez de duplicar el
 * mapa en dos ficheros. No es un componente de diseño y NO entra en ui-v2.5: es una tabla de
 * correspondencias de este dominio.
 */
const ICONO_RECURSO = {
  mail: Mail, smartphone: Smartphone, 'credit-card': CreditCard, laptop: Laptop, phone: Phone,
  car: Car, wallet: Wallet, shirt: Shirt, contact: Contact, code: Code,
};

export const IconoRecurso = ({ nombre, className }) => {
  const C = ICONO_RECURSO[nombre] || Package;
  return <C className={className} />;
};
